<template>

    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="nav-bar box-horizontal mb-0">
                        <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
                        <div class="flex-1">
                            <h3 class="m-0">Tambah Transaksi</h3>
                            <p class="mb-0">Pastikan Form terisi dengan benar</p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Keterangan</label>
                                            <input type="text" class="form-control" placeholder="Keterangan..." v-model="data.nama">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Jumlah (Pastikan Tarif paket tidak pakai titik/koma. Mis : 50000) {{ data.namaAdmin }}</label>
                                            <input type="number" class="form-control" placeholder="Jumlah..." v-model="data.tarif" min="0">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Tipe</label>
                                            <select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Resto..." v-model="data.tipe">
                                                <option value="" selected disabled>Pilih Tipe</option>
                                                <option value="keluar">Pengeluaran</option>
                                                <option value="masuk">Pemasukkan</option>
                                                <option value="setor">Setoran</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="data.tipe == 'setor'">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Pilih Admin</label>
                                            <p v-if="data.namaAdmin != null">{{ data.namaAdmin }}</p>

                                            <select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Admin..." v-model="data.admin" v-else>
                                                <option value="" selected disabled>Pilih Admin</option>
                                                <option v-for="(u, index) in data.listAdmin" :value="u.id">{{u.nama}}</option>
                                            </select>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="data.tipe == 'keluar'">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Kategori (Default : Lain-lain)</label>
                                            <select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Resto..."  v-model="data.kategori">
                                                <option value="" selected disabled>Pilih Kategori</option>
                                                <option value="1">Gaji Karyawan</option>
                                                <option value="2">Pasang Baru</option>
                                                <option value="3">Perbaikan Alat</option>
                                                <option value="4">Bayar Bandwith</option>
                                                <option value="5">Bayar Kang Tagih</option>
                                                <option value="6">Listrik / PDAM / Pulsa</option>
                                                <option value="7">Bayar Marketing</option>
                                                <option value="">Lain-lain</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                <div class="form-group">
                                    <button class="btn btn-primary" @click="form.simpan()">Simpan</button>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

var numeral = require("numeral");

Vue.use(moment)

export default {
	components: { 
		moment,
	}, 
    setup() {
        const data = reactive({
            loading: true,
            nama: '',
            tarif: '',
            tipe: '',
            kategori: '',
            listAdmin: [],

            admin: '',
            namaAdmin: null

        })

        const form = {
            simpan() {
                if (data.nama == "") {
                    alert("Keterangan tidak boleh kosong gan");
                    return;
                }
                if (data.tarif == "") {
                    alert("Jumlah tidak boleh kosong gan");
                    return;
                }
                if (data.tipe == "") {
                    alert("Tipe tidak boleh kosong gan");
                    return;
                }
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    bulan: sessionStorage.getItem('bulanIdBase'),
                    tahun: sessionStorage.getItem('tahunBase'),
                    keterangan: data.nama,
                    jumlah: data.tarif.replace(/[^0-9]/g, ''),
                    type: data.tipe,
                    kategori: data.kategori,
                    admin: data.admin
                }; 
            
                var apiUrl = inter.PembukuanTambah();
                myGlobal.call(datax,apiUrl).then(x => {
                        
                    console.log(JSON.stringify(x));

                    if (x.status == true) {

                        location.href="#/pembukuan"
                    
                    } else {
                        
                    }
                })
            },
            getAdminSetor() {

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken')
                }; 
            
                var apiUrl = inter.adminSetor();
                myGlobal.call(datax,apiUrl).then(x => {


                    if (x.status == true) {

                        data.listAdmin = x.data;
                    
                    } else {
                        
                    }

                })
            }
        }
        return {
            data,
            myGlobal,
            form
        }
    },
	mounted() {

        this.form.getAdminSetor();
        
        let datax = this.$route.params;

        if(datax.nama) {
            //console.log(JSON.stringify(data));

            this.data.namaAdmin = datax.nama;
            this.data.admin = datax.admin;
            this.data.tipe = 'setor';


        }

        
        console.log(this.data.namaAdmin);

	}
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pembukuan/pengeluaran-tambah.vue